// src/components/ChatBubble.jsx
import React, { useState, useEffect, useRef } from 'react';
import { FaComments, FaTimes, FaPaperPlane } from 'react-icons/fa';
import axios from 'axios';
import './ChatBubble.css'; // Create this CSS file for styling
import SEO from './SEO';


function ChatBubble() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const chatEndRef = useRef(null);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleInputChange = (e) => {
    if (e.target.value.length <= 200) {
      setInput(e.target.value);
    }
  };

  const handleSendMessage = async () => {
    if (input.trim() === '') return;

    const newMessage = { sender: 'user', text: input.trim() };
    setMessages((prev) => [...prev, newMessage]);
    setInput('');
    setIsLoading(true);

    try {
      const response = await axios.post('http://localhost:5000/api/chat', {
        message: newMessage.text,
      });

      const assistantMessage = { sender: 'assistant', text: response.data.message };
      setMessages((prev) => [...prev, assistantMessage]);
    } catch (error) {
      console.error('Error:', error.response?.data?.error || error.message);
      const errorMessage = { sender: 'assistant', text: 'Sorry, something went wrong. Please try again later.' };
      setMessages((prev) => [...prev, errorMessage]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isOpen]);

  return (
    <>
      <div className={`chat-bubble ${isOpen ? 'open' : ''}`} onClick={toggleChat} aria-label="Open Chat">
        {isOpen ? <FaTimes /> : <FaComments />}
      </div>

      {isOpen && (
        <div className="chat-window" role="dialog" aria-labelledby="chat-header">
          <div className="chat-header">
            <h3 id="chat-header">Christian Chat Assistant</h3>
            <FaTimes className="close-icon" onClick={toggleChat} aria-label="Close Chat" />
          </div>
          <div className="chat-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`message ${msg.sender}`}>
                <span>{msg.text}</span>
              </div>
            ))}
            {isLoading && (
              <div className="message assistant">
                <span>Typing...</span>
              </div>
            )}
            <div ref={chatEndRef} />
          </div>
          <div className="chat-input">
            <textarea
              value={input}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              placeholder="Ask a Christianity question..."
              maxLength="200"
              aria-label="Chat Input"
            ></textarea>
            <button onClick={handleSendMessage} disabled={isLoading || input.trim() === ''} aria-label="Send Message">
              <FaPaperPlane />
            </button>
          </div>
          <div className="character-count">
            {input.length}/200
          </div>
        </div>
      )}
    </>
  );
}

export default ChatBubble;
